module.exports = __webpack_public_path__ + "img/jiaotong.3347294e.jpg";